// Barre d'onglets en BAS de l'écran, sur téléphone (masquée au-delà de 940 px).
//
// Les écrans les plus visités sont à portée de pouce ; « Menu » ouvre le tiroir
// qui contient le menu complet du projet (le même que sur ordinateur).
import type { ReactNode } from 'react';
import { hrefFor, useRouter } from '../router';
import { Icon, type IconName } from '../components/icons';

interface Tab {
  slug: string;
  label: string;
  icon: IconName;
  /** Sous-écrans qui allument aussi cet onglet. */
  also?: string[];
}

const HOME: Tab = { slug: '', label: 'Accueil', icon: 'dashboard' };
const STUDIES: Tab = { slug: 'etudes', label: 'Études', icon: 'flask', also: ['entretiens', 'tests'] };
const INSIGHTS: Tab = { slug: 'insights', label: 'Insights', icon: 'bulb' };

export function MobileNav({
  base,
  section,
  menuOpen,
  onMenu,
  capture,
}: {
  base: string;
  section: string;
  menuOpen: boolean;
  onMenu: () => void;
  /** Bouton central « Capturer », en mode mobile seulement. */
  capture?: ReactNode;
}) {
  const { navigate } = useRouter();

  const tab = (t: Tab) => {
    const to = t.slug ? `${base}/${t.slug}` : base;
    const on = !menuOpen && (t.slug === section || (t.also?.includes(section) ?? false));
    return (
      <a
        key={t.slug || 'accueil'}
        href={hrefFor(to)}
        className={`mobile-tab${on ? ' is-on' : ''}`}
        aria-current={on ? 'page' : undefined}
        onClick={(e) => {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
          e.preventDefault();
          navigate(to);
        }}
      >
        <Icon name={t.icon} size={20} />
        <span>{t.label}</span>
      </a>
    );
  };

  return (
    <nav className="mobile-nav" aria-label="Navigation rapide">
      {tab(HOME)}
      {tab(STUDIES)}
      {capture}
      {tab(INSIGHTS)}
      <button type="button" className={`mobile-tab${menuOpen ? ' is-on' : ''}`} aria-expanded={menuOpen} onClick={onMenu}>
        <Icon name="menu" size={20} />
        <span>Menu</span>
      </button>
    </nav>
  );
}
